import { buildProductsDataWithIsm } from './collaborators/ism';
import { parseContentData } from './collaborators/content-data-helper';

export const WithInSortMarketing = ({
  children,
  contentData,
  categoryId,
  subCategoryId,
  divisionId,
  productData,
  isDesktop,
  numberOfProductsInARow,
}) => {
  const ISMData = parseContentData(contentData, {
    categoryId,
    subCategoryId,
    divisionId,
  });
  const productsToMap = buildProductsDataWithIsm({
    ISMData,
    isDesktop,
    numberOfProductsInARow,
    products: productData,
  }).objects;
  return children(productsToMap);
};
